import { Injectable } from '@angular/core';
import { of } from 'rxjs';
import { IPC_CHANNEL } from '../electron.constants';
import { ElectronService } from '../../electron.service';

@Injectable({
  providedIn: 'root'
})
export class OfflineCookieService {
  constructor(
    private _electronService: ElectronService,
  ) { }

  getCookies() {
    return of(this._electronService.sendSyncCommand(IPC_CHANNEL.COOKIE.GET_ALL, {}));
  }

  setCookies(token: any) {
    return of(this._electronService.sendSyncCommand(IPC_CHANNEL.COOKIE.SET, token));
  }

  deleteAllCookies() {
    return of(this._electronService.sendSyncCommand(IPC_CHANNEL.COOKIE.DELETE_ALL));
  }
}
